export default __webpack_public_path__ + "static/media/thinking-emoji.696c670f.png";